class TiloVersionsAccordion extends HTMLElement {
    constructor() {
        super();
        this.accordionItems = [];
        this.rightTabs = [];
        this.accordionContainer = null;
        this.isAnimating = false;
    }

    connectedCallback() {
        this.accordionItems = this.querySelectorAll('.tilo-version-item');
        this.rightTabs = this.querySelectorAll('.tilo-version-right-tab');
        this.accordionContainer = this.querySelector('.tilo-versions-accordion');
        this.init();
    }

    init() {
        this.accordionItems.forEach((item, index) => {
            const tab = item.querySelector('.tilo-version-tab');
            if (tab) {
                tab.addEventListener('click', () => this.activateTab(index));
                tab.addEventListener('keydown', (event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        this.activateTab(index);
                    }
                });
            }
        });

        this.rightTabs.forEach(tab => {
            tab.addEventListener('click', () => this.activateTab(parseInt(tab.dataset.index)));
            tab.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    this.activateTab(parseInt(tab.dataset.index));
                }
            });
        });

        const initialIndex = [...this.accordionItems].findIndex(item => item.classList.contains('active'));
        const activeIndex = initialIndex !== -1 ? initialIndex : 0;

        for (let i = activeIndex + 1; i < this.accordionItems.length; i++) {
            this.accordionItems[i].classList.add('after-active');
        }

        this.syncA11yState(activeIndex);
        setTimeout(() => this.activateTab(activeIndex, false), 100);
    }

    activateTab(index, animate = true) {
        if (this.isAnimating) return;

        const currentActive = [...this.accordionItems].findIndex(item => item.classList.contains('active'));
        if (currentActive === index) {
            this.syncA11yState(index);
            return;
        }

        if (animate && this.accordionContainer && window.innerWidth > 990) {
            this.isAnimating = true;
            const currentHeight = this.accordionContainer.offsetHeight;
            this.accordionContainer.style.height = `${currentHeight}px`;
            this.accordionContainer.style.overflow = 'hidden';
        }

        this.accordionItems.forEach(item => {
            item.classList.remove('active', 'after-active');
            const content = item.querySelector('.tilo-version-content');
            if (content) content.classList.remove('active');
        });

        this.rightTabs.forEach(tab => tab.classList.remove('active'));

        const activeItem = this.accordionItems[index];
        activeItem.classList.add('active');
        const selectedContent = activeItem.querySelector('.tilo-version-content');
        if (selectedContent) selectedContent.classList.add('active');
        if (this.rightTabs[index]) this.rightTabs[index].classList.add('active');

        for (let i = index + 1; i < this.accordionItems.length; i++) {
            this.accordionItems[i].classList.add('after-active');
        }

        this.syncA11yState(index);

        if (animate && this.accordionContainer && window.innerWidth > 990) {
            setTimeout(() => {
                const newHeight = this.getContentHeight();
                this.accordionContainer.style.height = `${newHeight}px`;
                setTimeout(() => {
                    this.accordionContainer.style.height = '';
                    this.accordionContainer.style.overflow = '';
                    this.isAnimating = false;
                }, 300);
            }, 10);
        }
    }

    getContentHeight() {
        const activeItem = this.querySelector('.tilo-version-item.active');
        return activeItem ? activeItem.offsetHeight : 0;
    }

    syncA11yState(activeIndex) {
        this.accordionItems.forEach((item, index) => {
            const tab = item.querySelector('.tilo-version-tab');
            const content = item.querySelector('.tilo-version-content');
            const isActive = index === activeIndex;

            if (tab) {
                tab.setAttribute('aria-expanded', String(isActive));
            }

            if (content) {
                content.setAttribute('aria-hidden', String(!isActive));
            }
        });
    }
}

customElements.define('tilo-versions-accordion', TiloVersionsAccordion);
